/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Biz_NameInputs */

const en_mk_price_biz_name = /** @type {(inputs: Mk_Price_Biz_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business`)
};

const id_mk_price_biz_name = /** @type {(inputs: Mk_Price_Biz_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisnis`)
};

/**
* | output |
* | --- |
* | "Business" |
*
* @param {Mk_Price_Biz_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_biz_name = /** @type {((inputs?: Mk_Price_Biz_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Biz_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_biz_name(inputs)
	return en_mk_price_biz_name(inputs)
});